import { Query } from 'redux-little-router';
import { createSelector } from 'reselect';

import { SortDirection } from '../typings/grid';
import { State } from '../typings/state';

const FREELANCERS_LIST_DEFAULT_SORT_DIRECTION = SortDirection.asc;

export const selectFreelancersListSortParams = createSelector(
    (state: State) => state.router.query,
    (query?: Query) => {
        if (query && query.key) {
            return {
                key: query.key,
                direction:
                    SortDirection[query.direction] ||
                    FREELANCERS_LIST_DEFAULT_SORT_DIRECTION
            };
        }
        return undefined;
    }
);
